 <template>
  <v-alert type="error">{{message}} </v-alert>
</template>
<script>
export default {
    props: ["message"]
}
</script>